// extracted by mini-css-extract-plugin
module.exports = {"flexWrapper":"InlineSegment-module--flexWrapper--31nGs","inlineSegment":"InlineSegment-module--inlineSegment--3Ks8g"};